'use strict';

angular.module('ringbaPortal.services').factory('callRouteService', callRouteService);

function callRouteService($http, authService, ngAuthSettings) {
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const service = {
    getCallRoutes: getCallRoutes,
    getCallRoute: getCallRoute,
    createCallRoute: createCallRoute,
    updateCallRoute: updateCallRoute
  };
  return service;

  function getCallRoutes(accountId) {
    const url = serviceBaseUri + accountId + '/callroutes';
    return $http.get(url);
  }

  function getCallRoute(accountId, callRouteId) {
    const url = _serviceBaseUrl(accountId, callRouteId);
    return $http.get(url);
  }

  function createCallRoute(accountId, callRoute) {
    const url = serviceBaseUri + accountId + '/callroutes';
    return $http.post(url, callRoute);
  }

  function updateCallRoute(accountId, callRoute) {
    const url = _serviceBaseUrl(accountId, callRoute.id);
    return $http.patch(url, _sanitizedCallRoute(callRoute));
  }

  function _sanitizedCallRoute(callRoute) {
    return {
      id: callRoute.id,
      priority: callRoute.priority,
      conversionSettings: callRoute.conversionSettings
    };
  }

  function _serviceBaseUrl(accountId, callRouteId) {
    return serviceBaseUri + accountId + '/callroutes/' + callRouteId;
  }
}
